import React from "react";
import styles from './IndividualProjectContent.module.css';
import logo from '../../assets/les-logo.png';
import { FaGithub } from 'react-icons/fa'
import ProfileCard from "../ProfileCard/ProfileCard";

function IndividualProjectContent() {
    return (
        <section className={styles.project}>
            <h1>Título do Projeto</h1>

            <div className={styles.container}>
                <section className={styles.descriptiveContainer}>
                    <div className={styles.imgContainer}>
                        <img src={logo} alt="logo" className={styles.image} />
                        <img src={logo} alt="logo" className={styles.image} />
                        <img src={logo} alt="logo" className={styles.image} />
                    </div>
                    <p>
                        Lorem Ipsum é simplesmente uma simulação de texto da indústria tipográfica e de impressos, e vem sendo utilizado desde o século XVI, quando um impressor desconhecido pegou uma bandeja de tipos e os embaralhou para fazer um livro de
                    </p>
                    <div className={styles.participantsContainer}>
                        <h3> Participantes: </h3>
                        <p>Descrição dos participantes</p>
                    </div>
                    <div className={styles.artifactsContainer}>
                        <h3> Artefartos: </h3>
                        <p>Descrição dos artefatos</p>
                    </div>
                </section>

                <section className={styles.informativeContainer}>

                    <div className={styles.logoContainer}>
                        <img src={logo} alt="logo" className={styles.logo} />
                    </div>

                    <div className={styles.clientDateContainer}>
                        <div className={styles.clientContainer}>
                            <h3> Cliente: </h3>
                            <p>Descrição de cliente</p>
                        </div>
                        <div className={styles.dateContainer}>
                            <h3> Data: </h3>
                            <p>00/00/0000</p>
                         </div>
                    </div>
                    
                    <div className={styles.serviceContainer}>
                        <h3> Serviço: </h3>
                        <p>Descrição dos serviços</p>
                    </div>

                    <div className={styles.iconContainer}>
                        <FaGithub className={styles.icon} size={40} data-testid="github-icon" />
                    </div>

                </section>
            </div>
            <section className={styles["members-container"]}>

                <h3> Participantes: </h3>
                <div className={styles['profilecards-container']}>
                    <ProfileCard name="Nome do Usuário" seeMore="Ver Mais" imageUrl={logo} withButton={true} withIconGit={true}  />
                </div>
            </section>
        </section>
    );
}

export default IndividualProjectContent;
